import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useDocumentTitle } from '@hooks';
import ToolCard from './ToolCard/ToolCard';
import PageBase from '../../components/PageBase/PageBase';
import settings from '../../settings';
import classes from './Index.styles.less';
export default function Index() {
    useDocumentTitle('Omatsuri');
    const tools = settings.tools.map((tool) => (_jsx(ToolCard, { className: classes.tool, ...tool }, tool.name)));
    return (_jsx(PageBase, { children: _jsx("div", { className: classes.tools, children: tools }) }));
}
